exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".resp-tab-disabled[data-v-3f290ba4]{color:#d2d2d2!important;cursor:not-allowed}.mt-20[data-v-3f290ba4]{margin-top:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3f290ba4","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/views/fundraisers/components/show/PageShowFundraiser.vue
// module id = 190
// module chunks = 0